module.exports = __webpack_public_path__ + "media/img/testimonial/aaron_lee_all_to_gather-f73d5408053c676c410844861f1f384d.jpg";